import type {
  AlertBanner,
  AlertConfiguration,
  BannerType,
} from '@generated/graphql';
import type { SvgIconComponent } from '@mui/icons-material';
import type { PaletteToken } from 'hephaestus/core';
import type { TableHeaderKeys } from './constants';

export enum AlertBannerStatus {
  ACTIVE = 'ACTIVE',
  SCHEDULED = 'SCHEDULED',
  DRAFT = 'DRAFT',
  EXPIRED = 'EXPIRED',
}

type TableHeader = {
  key: TableHeaderKeys;
  isSortable?: boolean;
  labelPath: string;
  permissions?: string[];
};

export type AlertBannerTable = TableHeader[];

export interface AlertBannerRow extends AlertBanner {
  status: AlertBannerStatus;
}

export type BannerTypeOption = {
  key: BannerType;
  icon: SvgIconComponent;
  backgroundColor: keyof PaletteToken;
  iconColor: keyof PaletteToken;
};

export type ConfigurationField = Exclude<
  keyof AlertConfiguration,
  '__typename'
>;
